<template>
    <div class="pageBox">
        <div class="ListBox">
            <div class="searchType">
                <span @click="selectedType(1)" :class="{on:searchType==1}">{{ searchTypeList[0].name }}</span>
                <span @click="selectedType(2)" :class="{on:searchType==2}">{{ searchTypeList[1].name }}</span>
                <span @click="selectedType(3)" :class="{on:searchType==3}">{{ searchTypeList[2].name }}</span>
            </div>
            <div class="ListBoxRow" v-if="searchList.length>0">
                <div class="ListFrame">
                    <div v-for="(item,index) in searchList"
                         @mouseover="isHover=true"
                         @mouseleave="isHover=false"
                         class="itemBox"
                         :key="index">
                        <router-link :to="searchType==1?{name:'ServeDetail',params:{sId:item.id}}
                        :searchType==2?{name:'ProductDetail',params:{pId:item.id}}
                        :searchType==3?{name:'NewsDetail',params:{nId:item.id}}:''"
                                     class="item">
                            <div class="imgBox">
                                <img :src="item.img" :alt="item.name">
                            </div>
                            <div class="name">{{ item.name }}</div>
                            <div class="info">{{ item.info }}</div>
                        </router-link>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-sizes="[8, 12, 16, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
            </div>
            <div class="nodata" v-else>{{ tip }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "search",
    data() {
        return {
            searchList: [],
            pageIndex: 1,
            pageSize: 8,
            totalCount: 11,
            searchStr: '',
            searchType: 1,
            searchTypeList: [
                {
                    name: '中安服务'
                },
                {
                    name: '在线下单'
                },
                {
                    name: '中安新闻'
                }
            ],
            tip: ''
        }
    },
    watch: {
        '$route.params.str'(){
            this.searchStr = this.$route.params.str
            this.setTips()
            this.getSearchList()
        }
    },
    mounted() {
        this.searchStr = this.$route.params.str
        this.setTips()
        this.getSearchList()
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getSearchList()
        },
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getSearchList()
        },

        /**
         * 获取搜索的数据
         * @param id 搜索类型 1服务，默认。 2产品 3新闻
         */
        getSearchList() {
            this.$post('/V1/Search/Search',
                {
                    "pageSize": this.pageSize,
                    "pageIndex": this.pageIndex,
                    "searchKey": this.searchStr,
                    "type": this.searchType
                })
                .then((res) => {
                    // console.log('search', res)
                    if (res.success) {
                        this.searchList = res.response.data
                        this.totalCount = res.response.totalCount
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 选择搜索类别
         * @param id
         */
        selectedType(id) {
            this.searchType = id
            this.getSearchList()
            this.setTips()
        },

        /**
         * 设置提示语
         */
        setTips() {
            var tmTip = this.searchStr + '_' + this.searchTypeList[this.searchType - 1].name;
            this.tip = `没有搜索到 "${tmTip}" 的相关信息，请换个搜索词试试。`
            document.title = tmTip + this.$suffix
        }
    }
}
</script>

<style scoped lang="less">
.pageBox {
    width: 100%;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;

    .ListBox {
        min-height: 400px;
        width: 1210px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;

        .searchType {
            padding-top: 50px;
            display: flex;
            flex-direction: row;
            align-content: center;
            justify-content: space-around;

            span {
                width: 320px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                background-color: white;
                color: #1f2d5c;
                font-size: 16px;
                border: 1px solid #1f2d5c;
            }

            .on, span:hover {
                background-color: #1f2d5c;
                color: white;
                cursor: pointer;
            }
        }

        .ListBoxRow {
            display: flex;
            flex-direction: column;
            padding: 20px 0px;

            .ListFrame {
                width: 1210px;
                margin: 0 auto 20px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                .itemBox {
                    margin-right: 18px;

                    .item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 20px;
                        width: 249px;
                        height: 211px;
                        background-color: white;
                        margin-top: 15px;
                        margin-bottom: 10px;
                        border-radius: 5px;

                        .imgBox {
                            width: 250px;
                            height: 125px;
                            overflow: hidden;
                            border: 1px solid #cccccc;
                            margin-bottom: 10px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .name {
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1f2d5c;
                            font-size: 18px;
                            max-width: 100%;
                            margin-top: 10px;
                            margin-bottom: 20px;
                            height: 24px;
                        }

                        .info {
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #999;
                            font-size: 15px;
                            max-width: 100%;
                            height: 20px;
                        }
                    }

                    .item:hover {
                        box-shadow: 0px 0px 10px 0px #d4d4d4;
                        margin-top: 1px;
                        margin-bottom: 24px;
                        transition: .4s;
                    }
                }

                .itemBox:nth-child(4n) {
                    margin-right: 0;
                }
            }

            .pagination {
                width: 1210px;
                margin: 0 auto;
            }
        }

        .nodata {
            width: 1210px;
            margin: 0 auto;
            line-height: 400px;
            color: red;
            width: fit-content;
        }
    }
}
</style>

